export default __webpack_public_path__ + "media/zurb/img/legacy/strike/instructions-2-23558069fe9cf6a4ed1ccf4627abc398.jpg";